import angular from 'angular';
import uiRouter from 'angular-ui-router';
import stDateTimePickerComponent from './stDateTimePicker.component';

let stDateTimePickerModule = angular.module('stDateTimePicker', [
  uiRouter
])

.component('stDateTimePicker', stDateTimePickerComponent)
.name;

export default stDateTimePickerModule;



// WEBPACK FOOTER //
// ./client/app/common/stDateTimePicker/stDateTimePicker.js